import { useEffect, useState } from "react";

export function usePageChange() {
  const [pageChange, setPageChange] = useState(Symbol());
  useEffect(() => {
    // Handle navigation using Temporal.InstantClick which doesn't actually reload the page.
    if (window.InstantClick) {
      window.InstantClick.on("change", () => {
        setPageChange(Symbol());
      });
    }
    window.addEventListener("pushstate", () => {
      setPageChange(Symbol());
    });
    window.addEventListener("popstate", () => {
      setPageChange(Symbol());
    });
  }, []);
  return pageChange;
}
